import $ from 'jquery';

const PartnerSystem = {
	init: function() {
		//this.checkStatus();
		this.bindEvents();
	},

	bindEvents: function() {
		// Partner login form
		$('#partner-login-form').on('submit', function(e) {
			e.preventDefault();
			const accessCode = $('#partner-access-code').val();
			PartnerSystem.verifyAccess(accessCode);
		});

		// Partner logout
		$('#partner-logout').on('click', function(e) {
			e.preventDefault();
			PartnerSystem.logout();
		});
	},

	checkStatus: function() {
		$.ajax({
			url: WpApp.ajaxurl,
			type: 'POST',
			data: {
				action: 'check_partner_status',
			},
			success: function(response) {
				if (response.success) {
					PartnerSystem.handleStatusResponse(response.data);
				}
			}
		});
	},

	verifyAccess: function(accessCode) {
		$.ajax({
			url: WpApp.ajaxurl,
			type: 'POST',
			data: {
				action: 'verify_partner_access',
				access_code: accessCode,
				nonce: WpApp.partner_nonce
			},
			beforeSend: function() {
				$('#partner-login-form').addClass('loading');
				$('#partner-login-message').hide();
			},
			success: function(response) {
				if (response.success) {
					PartnerSystem.handleSuccessfulLogin(response.data);
				} else {
					PartnerSystem.handleFailedLogin(response.data);
				}
			},
			complete: function() {
				$('#partner-login-form').removeClass('loading');
			}
		});
	},

	logout: function() {
		$.ajax({
			url: WpApp.ajaxurl,
			type: 'POST',
			data: {
				action: 'partner_logout',
				nonce: WpApp.partner_nonce
			},
			success: function(response) {
				if (response.success) {
					window.location.reload();
				}
			}
		});
	},

	handleStatusResponse: function(data) {
		if (data.is_logged_in) {
			$('.partner-logged-out').hide();
			$('.partner-logged-in').show();
			$('#partner-name').text(data.partner.name);
		} else {
			$('.partner-logged-in').hide();
			$('.partner-logged-out').show();
		}
	},

	handleSuccessfulLogin: function(data) {
		$('#partner-login-message')
			.removeClass('error')
			.addClass('success')
			.text(data.message)
			.show();

		$('.partner-logged-out').hide();
		$('.partner-logged-in').show();
		$('#partner-name').text(data.partner.name);

		// Optional: reload page
		setTimeout(function() {
			window.location.reload();
		}, 1000);
	},

	handleFailedLogin: function(message) {
		$('#partner-login-message')
			.removeClass('success')
			.addClass('error')
			.text(message)
			.show();
	}
};


export default PartnerSystem;
